import { render } from "./address-list.vue?vue&type=template&id=20ddd5ec&scoped=true"
import script from "./address-list.vue?vue&type=script&lang=js"
export * from "./address-list.vue?vue&type=script&lang=js"

import "./address-list.vue?vue&type=style&index=0&id=20ddd5ec&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ddd5ec"]])

export default __exports__